import { DetailedHTMLProps, FunctionComponent, HTMLAttributes, useEffect, useState } from "react";
import styles from "./styles.module.scss";

export type ContainerProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  direction?: Direction,
  verticalAlign?: VerticalAlign,
  horizontalAlign?: HorizontalAlign,
  gap?: number | string,
  width?: number | string,
  height?: number | string,
  spaceBetween?: boolean
};

export enum Direction {
  Column = "column",
  Row = "row",
}

export enum VerticalAlign {
  Top = "top",
  Middle = "middle",
  Bottom = "bottom",
}

export enum HorizontalAlign {
  Left = "left",
  Center = "center",
  Right = "right",
}

const Container: FunctionComponent<ContainerProps> = ({ className, children, direction, gap, height, horizontalAlign, spaceBetween, style, verticalAlign, width, ...props }: ContainerProps) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // useEffect

  if (direction === undefined) {
    direction = Direction.Column;
  }

  if (process.env.NODE_ENV === "development" && spaceBetween) {
    if (direction === Direction.Column && verticalAlign !== undefined) {
      console.warn("The \"spaceBetween\" property is set, so the \"verticalAlign\" one is ignored.");
    }
    else if (direction === Direction.Row && horizontalAlign !== undefined) {
      console.warn("The \"spaceBetween\" property is set, so the \"horizontalAlign\" one is ignored.");
    }
  }

  return (
    <div
      className={`${styles.container} ${styles[direction]} ${styles[horizontalAlign ?? HorizontalAlign.Center]} ${styles[verticalAlign ?? VerticalAlign.Middle]} ${spaceBetween ? styles.spaceBetween : ""} ${className ?? ""}`}
      style={(gap || width || height) ?
        Object.assign({
          gap: typeof gap === "number" ? `${gap}px` : gap,
          width:
            typeof width === "number"
              ? windowWidth <= width
                ? "100%"
                : `${width}px`
              : width,
          height: typeof height === "number" ? `${height}px` : height,
        }, style) :
        style
      }
      {...props}
    >
      {children}
    </div>
  );
};

export default Container;